import React from 'react';
import { MessageCircle } from 'lucide-react';
import { trackWhatsAppClick } from '../utils/analytics';

const WhatsAppButton = () => {
  const whatsappNumber = '918200886945';
  const message = 'Hello, I am interested in Care Pharmacy franchise opportunity.';
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWhatsAppClick('918200886945', 'floating_button')}
      style={{
        position: 'fixed',
        bottom: '30px',
        right: '30px',
        width: '60px',
        height: '60px',
        backgroundColor: '#25D366',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 12px rgba(37, 211, 102, 0.4)',
        zIndex: 9999,
        transition: 'all 0.3s ease',
        textDecoration: 'none',
        cursor: 'pointer'
      }}
      className="whatsapp-float-button"
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'scale(1.1)';
        e.currentTarget.style.boxShadow = '0 6px 20px rgba(37, 211, 102, 0.6)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 211, 102, 0.4)';
      }}
    >
      <MessageCircle size={30} color="white" fill="white" />
      
      <style>{`
        .whatsapp-float-button:hover {
          transform: scale(1.1);
        }
        
        @keyframes pulse {
          0% {
            box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
          }
          50% {
            box-shadow: 0 4px 20px rgba(37, 211, 102, 0.7);
          }
          100% {
            box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
          }
        }
        
        .whatsapp-float-button {
          animation: pulse 2s infinite;
        }
        
        @media (max-width: 768px) {
          .whatsapp-float-button {
            bottom: 20px;
            right: 20px;
            width: 55px;
            height: 55px;
          }
        }
      `}</style>
    </a>
  );
};

export default WhatsAppButton;
